import naja from 'naja';
import { LiveForm, Nette } from 'live-form-validation';
import Inputmask from 'inputmask';
import $ from 'jquery';
import Swal from 'sweetalert2';

import qrcode from 'qrcode-generator'; 
import css from "./styles.scss";

LiveForm.setOptions({
    showValid: true,
    controlErrorClass: 'input_holder--error',
    controlValidClass: 'input_holder--success',
    showAllErrors: true,
    messageErrorPrefix: '',
    showMessageClassOnParent: 'form-group'
});

global.Nette = Nette;
global.LiveForm = LiveForm;

function classNames(...values) {
    const result = [];
    values.forEach((value) => {
        if (Array.isArray(value)) {
            value.forEach((item) => {
                if (item) result.push(item);
            });
            return;
        }

        if (value) result.push(value);
    });

    return result.join(' ');
}

function fireSwal(options) {
    const customClass = options.customClass || {};

    return Swal.fire({
        ...options,
        customClass: {
            ...customClass,
            actions: classNames(customClass.actions, 'submit_holder'),
        },
    });
}

const PAGE_ZOOM_STORAGE_KEY = 'registrationPageZoom';
const PAGE_ZOOM_MIN = 0.8;
const PAGE_ZOOM_MAX = 1.5;
const PAGE_ZOOM_STEP = 0.1;

function readPageZoom() {
    try {
        const storedValue = window.localStorage.getItem(PAGE_ZOOM_STORAGE_KEY);
        const storedZoom = storedValue === null ? NaN : Number(storedValue);
        if (Number.isFinite(storedZoom)) {
            return Math.min(PAGE_ZOOM_MAX, Math.max(PAGE_ZOOM_MIN, storedZoom));
        }
    } catch (e) {
        // Local storage may be disabled; zoom still works for the current page.
    }

    return 1;
}

let pageZoom = readPageZoom();

function applyPageZoom(zoom) {
    pageZoom = Math.round(Math.min(PAGE_ZOOM_MAX, Math.max(PAGE_ZOOM_MIN, zoom)) * 10) / 10;
    document.documentElement.style.zoom = pageZoom === 1 ? '' : String(pageZoom);

    try {
        window.localStorage.setItem(PAGE_ZOOM_STORAGE_KEY, String(pageZoom));
    } catch (e) {
        // Local storage may be disabled; no persistence is needed in that case.
    }

    document.querySelectorAll('[data-page-zoom-out]').forEach(button => {
        button.disabled = pageZoom <= PAGE_ZOOM_MIN;
    });
    document.querySelectorAll('[data-page-zoom-in]').forEach(button => {
        button.disabled = pageZoom >= PAGE_ZOOM_MAX;
    });
    document.querySelectorAll('[data-page-zoom-value]').forEach(value => {
        value.textContent = Math.round(pageZoom * 100) + ' %';
    });
}

function initPageZoomControls(root) {
    const scope = root || document;
    const controlsList = scope.querySelectorAll('[data-page-zoom-controls]');
    if (!controlsList.length) return;

    controlsList.forEach(controls => {
        if (controls.dataset.pageZoomBound) return;
        controls.dataset.pageZoomBound = '1';

        const zoomOut = controls.querySelector('[data-page-zoom-out]');
        const zoomIn = controls.querySelector('[data-page-zoom-in]');

        if (zoomOut) zoomOut.addEventListener('click', () => applyPageZoom(pageZoom - PAGE_ZOOM_STEP));
        if (zoomIn) zoomIn.addEventListener('click', () => applyPageZoom(pageZoom + PAGE_ZOOM_STEP));
    });

    applyPageZoom(pageZoom);
}

function getConsumableStepperIdentity(item) {
    const input = item.querySelector('input[type="checkbox"][name^="consumables"]');
    if (!input) return null;

    const value = String(input.value || '').match(/^(.*)__([1-9]\d*)$/);
    if (!value) return null;

    const rawGroup = input.dataset.group || '';
    const indexedGroupSuffix = '__' + value[2];

    return {
        item,
        input,
        productKey: value[1],
        index: Number(value[2]),
        groupKey: rawGroup && rawGroup.endsWith(indexedGroupSuffix)
            ? rawGroup.slice(0, -indexedGroupSuffix.length)
            : rawGroup,
        slotKey: rawGroup || value[1] + '__' + value[2],
    };
}

function setConsumableStepperButtonState(button, disabled) {
    button.disabled = disabled;
    button.classList.toggle('btn-step--disabled', disabled);
}

function createConsumableStepperCard(holder, cardProducts, sourceItems) {
    const card = document.createElement('div');
    card.className = 'filling_selection_card';

    const header = document.createElement('div');
    header.className = 'filling_selection_card__header';
    header.append(document.createTextNode('Celkem vybraných náplní: '));

    const count = document.createElement('span');
    count.className = 'filling_selection_card__count';

    const currentCount = document.createElement('span');
    currentCount.className = 'js-total-count';
    currentCount.setAttribute('aria-live', 'polite');
    count.append(currentCount, document.createTextNode(' / '));

    const enabledSlots = new Set(
        sourceItems
            .filter(source => !source.input.disabled && !source.item.classList.contains('sets_item--disabled'))
            .map(source => source.slotKey)
    );
    const max = enabledSlots.size;
    count.append(document.createTextNode(String(max)));
    header.append(count);

    const body = document.createElement('div');
    body.className = 'filling_selection_card__body';
    body.classList.toggle('filling_selection_card__body--single', cardProducts.length === 1);
    const productViews = [];

    cardProducts.forEach(product => {
        const example = product.sources[0].item;
        const item = document.createElement('div');
        item.className = 'filling_selection_item';

        const name = document.createElement('div');
        name.className = 'filling_selection_item__name';
        const sourceName = example.querySelector('.set_item__text');
        if (sourceName) name.innerHTML = sourceName.innerHTML;

        const stepper = document.createElement('div');
        stepper.className = 'filling_selection_item__stepper';

        const minus = document.createElement('button');
        minus.type = 'button';
        minus.className = 'btn-step btn-step--minus';
        minus.textContent = '-';
        minus.setAttribute('aria-label', 'Snížit počet');

        const value = document.createElement('input');
        value.type = 'text';
        value.className = 'step-value';
        value.value = '0';
        value.readOnly = true;
        value.tabIndex = -1;
        value.setAttribute('aria-label', 'Vybraný počet');

        const plus = document.createElement('button');
        plus.type = 'button';
        plus.className = 'btn-step btn-step--plus';
        plus.textContent = '+';
        plus.setAttribute('aria-label', 'Zvýšit počet');

        stepper.append(minus, value, plus);

        const imageWrap = document.createElement('div');
        imageWrap.className = 'filling_selection_item__image-wrap';
        const sourceSticker = example.querySelector('.set_item__sticker');
        if (sourceSticker) {
            const sticker = sourceSticker.cloneNode(true);
            sticker.className = 'filling_selection_item__sticker';
            imageWrap.append(sticker);
        }
        const sourceImage = example.querySelector('.set_item__image img');
        if (sourceImage) {
            const image = sourceImage.cloneNode(true);
            image.classList.add('filling-pack-img');
            if (!image.alt) image.alt = name.textContent.trim();
            imageWrap.append(image);
        }

        item.append(name, stepper, imageWrap);
        body.append(item);
        productViews.push({ product, value, minus, plus });
    });

    card.append(header, body);

    function isSlotSelected(slotKey) {
        return sourceItems.some(source => source.slotKey === slotKey && source.input.checked);
    }

    function getAvailableSource(product) {
        return product.sources.find(source => {
            return !source.input.checked
                && !source.input.disabled
                && !source.item.classList.contains('sets_item--disabled')
                && !isSlotSelected(source.slotKey);
        });
    }

    function updateVisibility() {
        card.hidden = sourceItems.every(source => source.item.hidden || source.item.style.display === 'none');
    }

    function update() {
        const total = sourceItems.filter(source => source.input.checked).length;
        currentCount.textContent = String(total);

        productViews.forEach(view => {
            const selected = view.product.sources.filter(source => source.input.checked);
            view.value.value = String(selected.length);
            setConsumableStepperButtonState(view.minus, selected.length === 0);
            setConsumableStepperButtonState(view.plus, total >= max || !getAvailableSource(view.product));
        });

        updateVisibility();
    }

    productViews.forEach(view => {
        view.minus.addEventListener('click', function() {
            if (this.disabled) return;

            const selected = view.product.sources.filter(source => source.input.checked);
            const source = selected[selected.length - 1];
            if (!source) return;

            source.input.checked = false;
            source.input.dispatchEvent(new Event('change', { bubbles: true }));
            update();
        });

        view.plus.addEventListener('click', function() {
            if (this.disabled) return;

            const source = getAvailableSource(view.product);
            if (!source) return;

            source.input.checked = true;
            source.input.dispatchEvent(new Event('change', { bubbles: true }));
            update();
        });
    });

    const firstSource = sourceItems[0].item;
    holder.insertBefore(card, firstSource);
    sourceItems.forEach(source => source.item.classList.add('sets_item--stepper-source'));

    const visibilityObserver = new MutationObserver(updateVisibility);
    sourceItems.forEach(source => {
        visibilityObserver.observe(source.item, { attributes: true, attributeFilter: ['hidden', 'style'] });
    });

    update();
    return { update };
}

function initConsumableSteppers(root) {
    const scope = root || document;
    const holders = Array.from(scope.querySelectorAll('.sets_holder'));
    if (scope.matches && scope.matches('.sets_holder')) holders.unshift(scope);

    holders.forEach(holder => {
        if (holder.dataset.consumableSteppersInitialized) return;

        const sources = Array.from(holder.children)
            .filter(item => item.classList.contains('sets_item'))
            .map(getConsumableStepperIdentity)
            .filter(Boolean);
        if (!sources.length) return;

        const products = new Map();
        sources.forEach(source => {
            if (!products.has(source.productKey)) {
                products.set(source.productKey, {
                    key: source.productKey,
                    groupKey: source.groupKey,
                    sources: [],
                });
            }
            products.get(source.productKey).sources.push(source);
        });

        const cards = new Map();
        products.forEach(product => {
            const cardKey = product.groupKey ? 'group:' + product.groupKey : 'product:' + product.key;
            if (!cards.has(cardKey)) cards.set(cardKey, []);
            cards.get(cardKey).push(product);
        });

        const controllers = [];
        cards.forEach(cardProducts => {
            const shouldUseStepper = cardProducts.length > 1
                || cardProducts.some(product => product.sources.length > 1);
            if (!shouldUseStepper) return;

            const cardSources = cardProducts
                .flatMap(product => product.sources)
                .sort((a, b) => a.index - b.index);
            controllers.push(createConsumableStepperCard(holder, cardProducts, cardSources));
        });

        if (!controllers.length) return;

        holder.dataset.consumableSteppersInitialized = '1';
        holder.classList.add('sets_holder--with-steppers');
        holder.consumableStepperControllers = controllers;
    });
}

document.addEventListener('change', function(event) {
    const source = event.target.closest && event.target.closest('.sets_item--stepper-source');
    if (!source) return;

    const holder = source.closest('.sets_holder');
    if (!holder || !holder.consumableStepperControllers) return;

    window.setTimeout(function() {
        holder.consumableStepperControllers.forEach(controller => controller.update());
    }, 0);
});

const NajaLiveValidationFallback = {
    initialize(naja){
        naja.addEventListener('init', function() {
            document.querySelectorAll('input[type="submit"], input[type="button"], form button').forEach(element => {
                element.addEventListener('click', this.processForm);
            });
        }.bind(this));
    },

    processForm(event) {
        const element = event.target;
        if (element.form !== undefined && element.form !== null) {
            element.form['nette-submittedBy'] = element;
        }
    }
}

const NajaPreventDoubleSubmission = {
    initialize(naja){
        naja.addEventListener('init', function() {
            // Prevent Double Submits
            document.querySelectorAll('form').forEach(form => {
                form.addEventListener('submit', (e) => {
                    if ((typeof form.validationState === "undefined") || (form.validationState == true)){
                        if (form.classList.contains('is-submitting')) {
                            e.preventDefault();
                        }
                        form.classList.add('is-submitting');
                    }
                });
            });
        }.bind(this));
    }
}

document.addEventListener('DOMContentLoaded', function () {
    const birthInput = document.querySelector('[name="birth"]');

    if (birthInput) {
        birthInput.addEventListener('blur', function () {
            this.dispatchEvent(new Event('change', { bubbles: true }));
        });
    }
});

naja.addEventListener('success', (event) => {
    if (event.detail.payload.success) {
        const target = document.getElementById('h1');
        if (target) {
            target.scrollIntoView({ behavior: 'smooth' });
        }
    }

    if (event.detail.payload.flashes) {
        const target = document.getElementById('snippet--flashes');
        if (target) {
            target.scrollIntoView({behavior: 'smooth', block: 'start'});
        }
    }
});

document.addEventListener('DOMContentLoaded', () => {
    document.addEventListener('submit', function (event) {
        const form = event.target;
        if (!form.matches('[data-age-verification-form]') || !window.fetch) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        if (form.dataset.ageVerificationBusy === '1') return;
        if (window.Nette && typeof window.Nette.validateForm === 'function' && !window.Nette.validateForm(form)) return;
        form.dataset.ageVerificationBusy = '1';
        const submit = form.querySelector('[type="submit"]');
        const body = new FormData(form);
        if (submit) submit.disabled = true;
        const previousError = form.querySelector('.age-verification-ajax-error');
        if (previousError) previousError.remove();
        fetch(form.action || window.location.href, {
            method: 'POST',
            body,
            credentials: 'same-origin',
            headers: {'X-Requested-With': 'XMLHttpRequest'}
        }).then(function (response) {
            if (!response.ok) throw new Error('Age verification failed');
            return response.json();
        }).then(function (payload) {
            if (!payload || payload.ageVerified !== true) throw new Error('Age verification was not accepted');
            const modal = form.closest('.modal_wrapper');
            if (modal) modal.style.display = 'none';
        }).catch(function () {
            let error = form.querySelector('.age-verification-ajax-error');
            if (!error) {
                error = document.createElement('div');
                error.className = 'alert alert-danger age-verification-ajax-error';
                error.setAttribute('role', 'alert');
                form.prepend(error);
            }
            error.textContent = 'Ověření věku se nepodařilo dokončit. Zkuste to prosím znovu.';
        }).finally(function () {
            delete form.dataset.ageVerificationBusy;
            form.classList.remove('is-submitting');
            if (submit) submit.disabled = !form.elements.ageConfirmed.checked;
        });
    }, true);
    naja.registerExtension(NajaLiveValidationFallback);
    //naja.registerExtension(NajaPreventDoubleSubmission);
    naja.initialize();
    Nette.initOnLoad();
    try {
        require('../../vendor/contributte/recaptcha/assets/invisibleRecaptcha');
    } catch(e){
        console.log("Not using recaptcha");
    }
    naja.snippetHandler.addEventListener('afterUpdate', (event) => {
        $(event.snippet).find('form').each(function() {
            window.Nette.initForm(this);
        });
        $(event.snippet).find('.fade-on-load').each(function(){
            $(this).hide().fadeIn();
        });
        initQuestionnaireSectionToggles(event.snippet);
        initQuestionnaireWizards(event.snippet);
        initPageZoomControls(event.snippet);
        initConsumableSteppers(document);
    });
    Inputmask().mask(document.querySelectorAll('input[data-inputmask]'));
    Inputmask({
        alias: "datetime",
        inputFormat: "dd.mm.yyyy",
        placeholder: "dd.mm.rrrr",
        showMaskOnHover: false,
        showMaskOnFocus: false,
        clearIncomplete: false,
    }).mask('input[name="birth"]');
    
    Array.from(document.getElementsByClassName("generate-qr")).forEach((e)=>{
        var qr = qrcode(e.dataset.type ?? 0, e.dataset.erroCorrection ?? 'L');
        qr.addData(e.dataset.data);
        qr.make();
        e.innerHTML =qr.createSvgTag({
            "cellSize" : 4,
            "margin" : 4,
            "scalable" : false
        });
    });
    Array.from(document.querySelectorAll('[data-display-after]')).forEach((e) => {
        const displayDate = new Date(e.dataset.displayAfter * 1000);
        const waitFor = displayDate - Date.now();
        var showElement = ()=>{e.classList.remove('d-none')};
        if (waitFor <= 0){
            showElement()
        } else {
            setTimeout(showElement, waitFor);
        }
    });

    const inputs = document.querySelectorAll('.number_code input');
    const hiddenInput = document.getElementById('kod_register');
    inputs.forEach(input => {
        input.addEventListener('input', () => {
            // Limit input to a single digit
            input.value = input.value.replace(/[^0-9]/g, '');

            // Collect all values
            let code = '';
            inputs.forEach(i => {
                code += i.value.trim();
            });

            // Set the combined code to the hidden input
            hiddenInput.value = code;
        });
    });

    const input = document.querySelector('.focusMe');
    input?.setSelectionRange(input.value.length, input.value.length) || input?.focus();

});
Nette.origIsDisabled = Nette.isDisabled;
Nette.isDisabled = function(elem){
    var result = Nette.origIsDisabled(elem);
    if (!result){
        result = elem.classList.contains('validation-waiting');
    }
    return result;
}

Nette.origValidateForm = Nette.validateForm;
Nette.validateForm = function(sender, onlyCheck){
    const form = sender.form || sender;

    // A valid submit marks the form as busy below. Reject every following
    // submit until the current request finishes or the browser navigates away.
    if (form.classList.contains('is-submitting')) {
        return false;
    }

    var result = Nette.origValidateForm(sender, onlyCheck);
    if (result){
        Array.from(sender.querySelectorAll('template.fire-on-submit')).forEach((template) => {
            if (!result) return;
            var style = window.getComputedStyle(template.parentElement);
            if (style.display !== 'none'){
                result = false;
                fireSwal({template: template}).then((swalResult) => {
                    if (swalResult.isConfirmed){
                        sender.classList.add("is-submitting");
                        sender.submit();
                    } else {
                        sender.classList.remove("is-submitting");
                    }
                });
            }
        });
    }

    // prevent dbl-submit
    if (result) {
        form.classList.add('is-submitting');
    }

    sender.validationState = result;
    return result;
}

Nette.validators.UIFormJavascriptCallbackValidator_validate = function(elem, args, val) {
    if (args.hasOwnProperty('callback')) {
        if (elem.hasOwnProperty('validationState')){
            switch (elem.validationState){
                case 'valid' : 
                    return true;
                case 'invalid' : 
                    return false;
                case 'waiting' :
                    return ;
            }
        } else {
            elem.addEventListener('change', (event) => {
                elem.validationState = 'changed';
            })
        }
        elem.classList.add('validation-waiting');
        elem.validationState = 'waiting';
                // pro naja 2.5 lze použít string pro identifikaci stornovaného požadavku
        var uniqueId = elem.form.id + '-' + elem.name;
        naja.makeRequest('GET', args.callback, { value: val }, { history: false, snippets: true, abort: false, unique: uniqueId })
            .then((response) => {
                elem.classList.remove('validation-waiting');
                elem.validationState = response.result ? 'valid' : 'invalid';
                if (response.result) {
                    LiveForm.removeError(elem);
                } else {
                    LiveForm.addError(elem,
                        response.hasOwnProperty('message') ? response.message :
                            args.hasOwnProperty('message') ? args.message :
                                'Please enter a valid value.'
                    );
                }
            })
        ;
        return ;
    }
    return true;
};

function restoreConfirmedConsentCheckbox(input) {
    input.dataset.confirmUncheckRestoring = '1';
    input.checked = true;
    $(input).trigger('change');
    delete input.dataset.confirmUncheckRestoring;
}

let wasChecked = false;

$(document).on('click', '.toggle_box__item-header', function() {
    $(this).closest(".toggle_box__item").toggleClass('active');
}).on('click', '.main_menu_toggler', function() {
    $(this).toggleClass("active").find('.menu_icon').toggleClass('open');
    $('.main_menu').fadeToggle();
}).on('click', '.fake_select__title', function() {
    $(this).closest('.fake_select').toggleClass('active');
}).on('click', '.styled_select .styled_select__title', function() {
    $(this).closest('.styled_select').toggleClass('active');
}).on('mousedown', '.product_item', function() {
    var $radio = $(this).find('input[type="radio"]');
    if ($radio.prop('checked')) {
        $(this).on('mouseup.uncheck', function () {
            setTimeout(function () {
                $radio.prop('checked', false).trigger('change');
            }, 5);
            $(this).off('mouseup.uncheck'); // unbind jen náš custom event
        });
    }
}).on('change', '.product_item input:radio[name="zarizeni"]', function() {
    const $form = $(this).closest('form');
    $form.find(".fake_select__inner input:radio[name='barva']").prop('checked', false);
    const hasDevice = $form.find("input:radio[name='zarizeni']:checked").length > 0;
    $form.find('.fake_select__title.barva').html(hasDevice ? 'Vyberte barvu zařízení' : 'Vyberte zařízení');
}).on('change', '.sets_item input[type="checkbox"]', function () {
    let group = $(this).data('group');
    $(`input[data-group="${group}"]`).not(this).prop('checked', false);
}).on('change', 'input[data-confirm-uncheck-consent="1"]', function() {
    if (this.dataset.confirmUncheckRestoring === '1' || this.checked) {
        return;
    }

    const input = this;
    fireSwal({
        icon: 'warning',
        title: input.dataset.confirmUncheckTitle || 'Zrušit souhlas?',
        html: input.dataset.confirmUncheckText || 'Opravdu chcete zrušit již udělený souhlas?',
        showCancelButton: true,
        confirmButtonText: input.dataset.confirmUncheckConfirm || 'Ano, zrušit souhlas',
        cancelButtonText: input.dataset.confirmUncheckCancel || 'Nechat souhlas',
        reverseButtons: true,
    }).then(function(result) {
        if (!result.isConfirmed) {
            restoreConfirmedConsentCheckbox(input);
        }
    });
}).on('click', '.brand_select__item', function() {
    $(".product_item input:radio[name='zarizeni']").prop('checked', false);
    $(".fake_select__inner input:radio[name='barva']").prop('checked', false);
    $('.fake_select__title.barva').html('Vyberte zařízení');
}).on("click", function(event){
    if(!$(event.target).closest(".fake_select").length){
        $(".fake_select").toggleClass('active', false);
    }
    if(!$(event.target).closest(".styled_select").length){
        $(".styled_select").toggleClass('active', false);
    }
}).on('click', '.fake_select label', function() {
    const $fakeSelect = $(this).closest('.fake_select');
    $fakeSelect.find('.fake_select__title').html('<div class="color_selected">' + $(this).html() + '</div>');
    $fakeSelect.find('.fake_select__inner input').checked = true;
    $fakeSelect.toggleClass('active');
}).on('click', '.styled_select label', function() {
    const $styledSelect = $(this).closest('.styled_select');
    $styledSelect.find('.styled_select__title').html('<div class="color_selected">' + $(this).html() + '</div>');
    $styledSelect.toggleClass('active', false);
}).on('keypress', 'form', function (e) {
    var code = e.keyCode || e.which;
    if (code == 13) {
        e.preventDefault();
        $(this).find('input[type=submit][name=submit]').click();
        return false;
    }
}).on('submit', 'form', function(e) {
    const submitter = e.originalEvent && e.originalEvent.submitter;
    if (submitter && submitter.name === 'prev') {
        return true;
    }

    var $this = $(this);
    if (!openFirstInvalidQuestionnaireControl(this)) return false;
    if (typeof $this.valid == 'undefined'){
        return true;
    }
    if (!$(this).valid()) return false;
    $('input[type=submit]').attr("disabled", "disabled");
    return true;
}).on('click', '.filling_metter__more', function (e) {
    e.preventDefault();
    $('.filling__registered_sets').slideToggle();
    $(this).toggleClass('active');
}).on('click', '[data-toggle-uncheck]', function() {
    const targetIds = String($(this).data('toggle-uncheck') || '').split(',');
    targetIds.forEach(function(id) {
        id = id.trim();
        if (!id) return;
        const $target = findInputByConfiguredId(id);
        $target.prop('checked', false).trigger('change');
    });
}).on('click', '.validate_modal', function(e) {
    let valid = true;
    const $modal = $(this).closest('.modal_wrapper');

    $modal.find('input, select, textarea')
        .not(':button, :submit, :reset, [disabled]')
        .filter(function() {
            return !$(this).closest('[hidden]').length;
        })
        .each(function() {
            if (!Nette.validateControl(this)) {
                valid = false;
                const $inner = $(this).closest('.modal_inner');
                if ($inner.length) {
                    $inner.animate({ scrollTop: Math.max(0, $(this).position().top - 40) }, 200);
                }
                return false;
            }
        });

    if (!valid) {
        e.preventDefault();
        e.stopImmediatePropagation();
        return false;
    }
}).on('click', '.modal_wrapper .close_modal', function(e){
    e.preventDefault();
    $(this).closest(".modal_wrapper").fadeOut();
}).on('click', '[data-open-section]', function(e) {
    e.preventDefault();
    const section = document.getElementById(this.dataset.openSection);
    if (!section) return;

    openQuestionnaireSection(section, true);
}).on('input', '.number_code input', function(){

    // Get the current input field
    var $this = $(this);

    // Ensure only one number is entered
    var value = $this.val().replace(/[^0-9]/g, '');
    $this.val(value);

    // Add the "filled" class if there is a number, otherwise remove it
    if (value) {
        $this.addClass('filled');
    } else {
        $this.removeClass('filled');
    }

    // Automatically move to the next input if there is a number
    if (value) {
        var $nextInput = $this.nextAll('input').first();

        if ($nextInput.length > 0) {
            // Focus the next input
            $nextInput.focus();
        } else {
            // Check if all inputs are filled before submitting the form
            var $form = $this.closest('form');
            var allFilled = $this.closest('.number_code').find('input').toArray().every(function (input) {
                return $(input).val().trim() !== '';
            });

            if (allFilled) {
                // Dispatch a submit event to trigger any submit listeners
                const submitEvent = new Event('submit', { bubbles: true, cancelable: true });
                if ($form[0].dispatchEvent(submitEvent)) {
                    // Only submit programmatically if the event was not canceled
                    $form[0].submit();
                }
            }
        }
    }

}).on('keydown', '.number_code input', function (e) {
    const $this = $(this);
    if (e.key === 'Backspace' && !$this.val()) {
        const $prevInput = $this.prevAll('input').first();
        if ($prevInput.length > 0) {
            $prevInput.focus();
        }
    }
});

function splitSectionIds(value) {
    return (value || '')
        .split(',')
        .map(sectionId => sectionId.trim())
        .filter(sectionId => sectionId.length > 0);
}

function findInputByConfiguredId(configuredId) {
    let $target = $('#' + configuredId);
    if ($target.length) {
        return $target;
    }

    $target = $('input').filter(function() {
        return this.id === configuredId || this.id.endsWith('-' + configuredId);
    });
    if ($target.length) {
        return $target;
    }

    const lastDash = configuredId.lastIndexOf('-');
    if (lastDash === -1) {
        return $();
    }

    const field = configuredId.slice(0, lastDash);
    const value = configuredId.slice(lastDash + 1);

    return $('input').filter(function() {
        return this.name.endsWith('[' + field + ']') && this.value === value;
    });
}

function setQuestionnaireSectionHidden(section, hidden) {
    section.hidden = hidden;
    if (hidden) {
        $(section).find('.modal_wrapper').hide();
    }
}

function openQuestionnaireSection(section, animate) {
    section.hidden = false;

    const $modals = $(section).find('.modal_wrapper');
    if (!$modals.length) {
        return;
    }

    if (animate) {
        $modals.stop(true, true).fadeIn();
    } else {
        $modals.show();
    }

    section.querySelector('.modal_inner')?.scrollTo(0, 0);
}

function openFirstInvalidQuestionnaireControl(form) {
    if (typeof Nette === 'undefined' || typeof Nette.validateControl !== 'function') {
        return true;
    }

    const controls = Array.from(form.querySelectorAll('input, select, textarea'));
    const firstInvalid = controls.find(control => {
        if (control.disabled || ['button', 'submit', 'reset'].includes(control.type)) {
            return false;
        }
        if (control.closest('[hidden]')) {
            return false;
        }

        return !Nette.validateControl(control);
    });

    if (!firstInvalid) {
        return true;
    }

    const section = firstInvalid.closest('.toggle-inner-modal');
    if (section) {
        openQuestionnaireSection(section, false);
    }

    const scrollTarget = firstInvalid.closest('.modal_inner') || firstInvalid.closest('.styled_form') || form;
    setTimeout(function() {
        if (scrollTarget && scrollTarget.scrollTo) {
            scrollTarget.scrollTo({
                top: Math.max(0, firstInvalid.offsetTop - 80),
                behavior: 'smooth'
            });
        }
        if (typeof firstInvalid.focus === 'function') {
            firstInvalid.focus({ preventScroll: true });
        }
    }, 0);

    return false;
}

document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('[data-toggle-section]').forEach(function(input) {
        input.addEventListener('change', function() {
            const section = document.getElementById(this.dataset.toggleSection);
            if (section) {
                section.hidden = !this.checked;
            }
        });

        if (input.checked) {
            const section = document.getElementById(input.dataset.toggleSection);
            if (section) section.hidden = false;
        }
    });
});

function getInputGroup(input, type) {
    return Array.from(document.querySelectorAll('input[type="' + type + '"]')).filter(item => {
        return item.name === input.name && item.form === input.form;
    });
}

function updateSectionsForRadioGroup(radio, openShownSections) {
    const group = getInputGroup(radio, 'radio').filter(item => item.dataset.hideSections || item.dataset.showSections);
    const checkedRadio = group.find(item => item.checked);
    const allAffectedSections = new Set();

    group.forEach(item => {
        splitSectionIds(item.dataset.hideSections).forEach(id => allAffectedSections.add(id));
        splitSectionIds(item.dataset.showSections).forEach(id => allAffectedSections.add(id));
    });

    allAffectedSections.forEach(sectionId => {
        const section = document.getElementById(sectionId);
        if (section) {
            setQuestionnaireSectionHidden(section, true);
        }
    });

    if (!checkedRadio) {
        return;
    }

    splitSectionIds(checkedRadio.dataset.hideSections).forEach(sectionId => {
        const section = document.getElementById(sectionId);
        if (section) {
            setQuestionnaireSectionHidden(section, true);
        }
    });

    splitSectionIds(checkedRadio.dataset.showSections).forEach(sectionId => {
        const section = document.getElementById(sectionId);
        if (!section) {
            return;
        }

        if (openShownSections) {
            openQuestionnaireSection(section, true);
        } else {
            section.hidden = false;
            $(section).find('.modal_wrapper').hide();
        }
    });
}

function getCheckboxGroup(checkbox) {
    return getInputGroup(checkbox, 'checkbox');
}

function enforceExclusiveOptions(checkbox) {
    if (!checkbox.checked) return;

    getCheckboxGroup(checkbox).forEach(item => {
        if (item === checkbox) return;

        if (checkbox.dataset.exclusiveOption || item.dataset.exclusiveOption) {
            item.checked = false;
        }
    });
}

function rememberInitialSectionState(section) {
    if (typeof section.dataset.initialHidden === 'undefined') {
        section.dataset.initialHidden = section.hidden ? 'true' : 'false';
    }
}

function updateSectionsForCheckboxGroup(checkbox, openShownSections) {
    const group = getCheckboxGroup(checkbox).filter(item => item.dataset.hideSections || item.dataset.showSections);
    const allAffectedSections = new Set();

    group.forEach(item => {
        splitSectionIds(item.dataset.showSections).forEach(sectionId => allAffectedSections.add(sectionId));
        splitSectionIds(item.dataset.hideSections).forEach(sectionId => allAffectedSections.add(sectionId));
    });

    allAffectedSections.forEach(sectionId => {
        const section = document.getElementById(sectionId);
        if (!section) return;

        rememberInitialSectionState(section);
        if (section.dataset.initialHidden === 'true') {
            setQuestionnaireSectionHidden(section, true);
        } else {
            section.hidden = false;
        }
    });

    group.filter(item => item.checked).forEach(item => {
        splitSectionIds(item.dataset.showSections).forEach(sectionId => {
            const section = document.getElementById(sectionId);
            if (!section) return;

            if (openShownSections) {
                openQuestionnaireSection(section, true);
            } else {
                section.hidden = false;
                $(section).find('.modal_wrapper').hide();
            }
        });

        splitSectionIds(item.dataset.hideSections).forEach(sectionId => {
            const section = document.getElementById(sectionId);
            if (section) setQuestionnaireSectionHidden(section, true);
        });
    });
}

function initQuestionnaireSectionToggles(root) {
    const scope = root || document;

    scope.querySelectorAll('input[type="radio"][data-hide-sections], input[type="radio"][data-show-sections]').forEach(radio => {
        if (!radio.dataset.questionnaireToggleBound) {
            radio.addEventListener('change', function() {
                updateSectionsForRadioGroup(this, true);
            });
            radio.dataset.questionnaireToggleBound = '1';
        }

        updateSectionsForRadioGroup(radio, false);
    });

    scope.querySelectorAll('input[type="checkbox"]').forEach(checkbox => {
        if (!checkbox.dataset.hideSections && !checkbox.dataset.showSections
            && !getCheckboxGroup(checkbox).some(item => item.dataset.exclusiveOption)) {
            return;
        }

        if (!checkbox.dataset.questionnaireToggleBound) {
            checkbox.addEventListener('change', function() {
                enforceExclusiveOptions(this);
                updateSectionsForCheckboxGroup(this, true);
            });
            checkbox.dataset.questionnaireToggleBound = '1';
        }

        updateSectionsForCheckboxGroup(checkbox, false);
    });
}

document.addEventListener('DOMContentLoaded', function() {
    initQuestionnaireSectionToggles(document);
});

function initQuestionnaireWizards(root) {
    const scope = root || document;

    scope.querySelectorAll('[data-wizard]').forEach(function(wizard) {
        if (wizard.dataset.questionnaireWizardBound) {
            return;
        }
        wizard.dataset.questionnaireWizardBound = '1';

        var steps = Array.from(wizard.querySelectorAll('[data-wizard-step]'));
        var progressFill = wizard.querySelector('[data-wizard-progress]');
        var progressText = wizard.querySelector('[data-wizard-progress-text]');
        var prevBtn = wizard.querySelector('[data-wizard-prev]');
        var nextBtn = wizard.querySelector('[data-wizard-next]');
        var finishBtn = wizard.querySelector('[data-wizard-finish]');
        var currentIndex = 0;
        var autoAdvanceTimer = null;

        function getVisibleSteps() {
            return steps.filter(function(step) {
                var wrapId = step.dataset.wizardWrap;
                if (wrapId) {
                    var wrapper = document.getElementById(wrapId);
                    if (wrapper && wrapper.closest('[hidden]')) {
                        return false;
                    }
                }
                return true;
            });
        }

        function updateProgress() {
            var visible = getVisibleSteps();
            var visibleIndex = visible.indexOf(steps[currentIndex]);
            if (visibleIndex === -1) visibleIndex = 0;
            var total = visible.length;
            var current = visibleIndex + 1;
            var pct = total > 0 ? Math.round((current / total) * 100) : 0;

            if (progressFill) progressFill.style.width = pct + '%';
            if (progressText) progressText.textContent = 'Otázka ' + current + ' z ' + total;
        }

        function showStep(index) {
            steps.forEach(function(step) { step.hidden = true; });
            if (steps[index]) {
                steps[index].hidden = false;
                var inner = wizard.closest('.modal_inner');
                if (inner) inner.scrollTo(0, 0);
            }

            var visible = getVisibleSteps();
            var visibleIndex = visible.indexOf(steps[index]);
            var isFirst = visibleIndex <= 0;
            var isLast = visibleIndex >= visible.length - 1;

            if (prevBtn) prevBtn.hidden = isFirst;
            if (nextBtn) nextBtn.hidden = isLast;
            if (finishBtn) finishBtn.hidden = !isLast;

            updateProgress();
        }

        function findNextVisibleIndex(fromIndex) {
            var visible = getVisibleSteps();
            var currentVisibleIdx = visible.indexOf(steps[fromIndex]);
            if (currentVisibleIdx < visible.length - 1) {
                return steps.indexOf(visible[currentVisibleIdx + 1]);
            }
            return -1;
        }

        function findPrevVisibleIndex(fromIndex) {
            var visible = getVisibleSteps();
            var currentVisibleIdx = visible.indexOf(steps[fromIndex]);
            if (currentVisibleIdx > 0) {
                return steps.indexOf(visible[currentVisibleIdx - 1]);
            }
            return -1;
        }

        function validateCurrentStep() {
            var step = steps[currentIndex];
            if (!step) return true;
            var valid = true;
            $(step).find('input, select, textarea').not(':button, :submit, :reset, [disabled]').filter(function() {
                return !$(this).closest('[hidden]').length;
            }).each(function() {
                if (!Nette.validateControl(this)) {
                    valid = false;
                    return false;
                }
            });
            return valid;
        }

        function goNext() {
            if (!validateCurrentStep()) return;
            var nextIdx = findNextVisibleIndex(currentIndex);
            if (nextIdx !== -1) {
                currentIndex = nextIdx;
                showStep(currentIndex);
            }
        }

        function goPrev() {
            var prevIdx = findPrevVisibleIndex(currentIndex);
            if (prevIdx !== -1) {
                currentIndex = prevIdx;
                showStep(currentIndex);
            }
        }

        if (nextBtn) nextBtn.addEventListener('click', goNext);
        if (prevBtn) prevBtn.addEventListener('click', goPrev);

        wizard.querySelectorAll('[data-wizard-auto-advance]').forEach(function(radio) {
            radio.addEventListener('change', function() {
                if (!this.checked) return;
                if (autoAdvanceTimer) clearTimeout(autoAdvanceTimer);
                autoAdvanceTimer = setTimeout(function() {
                    goNext();
                    autoAdvanceTimer = null;
                }, 400);
            });
        });

        var observer = new MutationObserver(function() {
            updateProgress();
            var visible = getVisibleSteps();
            if (visible.indexOf(steps[currentIndex]) === -1 && visible.length > 0) {
                currentIndex = steps.indexOf(visible[0]);
                showStep(currentIndex);
            }
        });
        steps.forEach(function(step) {
            var wrapId = step.dataset.wizardWrap;
            if (wrapId) {
                var wrapper = document.getElementById(wrapId);
                if (wrapper) {
                    observer.observe(wrapper, { attributes: true, attributeFilter: ['hidden'] });
                    if (wrapper.parentElement) {
                        observer.observe(wrapper.parentElement, { attributes: true, attributeFilter: ['hidden'] });
                    }
                }
            }
        });

        showStep(0);
    });
}

document.addEventListener('DOMContentLoaded', function() {
    initQuestionnaireWizards(document);
    initPageZoomControls(document);
    initConsumableSteppers(document);
});
